import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

type TextSize =
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | '2xl'
  | '3xl'
  | '4xl'
  | '5xl'
  | '6xl'
  | '7xl'
  | '8xl'
  | '9xl';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'itk-heading',
  templateUrl: './heading.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { @apply block; }'],
})
export class ItkHeadingComponent {
  @Input() size: TextSize = 'xl';
  @Input() position: 'center' | 'left' | 'right' = 'left';
  @Input() weight: 'light' | 'medium' | 'bold' | 'semibold' | 'normal' =
    'normal';

  get sizeClass(): string {
    switch (this.size) {
      case 'xs':
        return 'text-xs';
      case 'sm':
        return 'text-sm';
      case 'md':
        return 'text-md';
      case 'lg':
        return 'text-lg';
      case 'xl':
        return 'text-xl';
      case '2xl':
        return 'text-2xl';
      case '3xl':
        return 'text-3xl';
      case '4xl':
        return 'text-4xl';
      case '5xl':
        return 'text-5xl';
      case '6xl':
        return 'text-6xl';
      case '7xl':
        return 'text-7xl';
      case '8xl':
        return 'text-8xl';
      case '9xl':
        return 'text-9xl';
    }
  }

  get positionClass(): string {
    switch (this.position) {
      case 'left':
        return 'text-left';
      case 'center':
        return 'text-center';
      case 'right':
        return 'text-right';
    }
  }

  get weightClass(): string {
    switch (this.weight) {
      case 'light':
        return 'font-light';
      case 'normal':
        return 'font-normal';
      case 'medium':
        return 'font-medium';
      case 'semibold':
        return 'font-semibold';
      case 'bold':
        return 'font-bold';
    }
  }

  get classes(): string[] {
    return [this.sizeClass, this.positionClass, this.weightClass];
  }
}
